import { trim } from 'lodash';

import { createStateSelectorHook } from 'src/lib/sweetState';

import { MainStore } from '../store';

const useMainState = createStateSelectorHook(MainStore, ['promptData']);

export const useIsEmptyPrompt = () => {
  const { promptData } = useMainState();
  if (!promptData) {
    return true;
  }

  return trim(promptData.text).length === 0;
};
